// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Referral History — premium layout, matches site theme (Zillion: #1E56F5, success #5EBA89) */
.referral_recent_s.rh-referral-premium {
  /* Align with light_theme + global dashboard */
  --rh-brand: #1e56f5;
  --rh-brand-mid: #2156f5;
  --rh-brand-soft: rgba(30, 86, 245, 0.1);
  --rh-brand-border: rgba(30, 86, 245, 0.22);
  --rh-success: #5eba89;
  --rh-success-soft: rgba(94, 186, 137, 0.16);
  --rh-surface: #ffffff;
  --rh-surface-muted: #f8f9fa;
  --rh-surface-elev: #f0f0f0;
  --rh-border: #f0f0f0;
  --rh-border-strong: #e2e4e8;
  --rh-text: rgba(0, 0, 0, 0.72);
  --rh-text-heading: #000000b8;
  --rh-muted: #6c757d;
  --rh-warn: #b45c06;
  --rh-warn-soft: rgba(180, 92, 6, 0.12);
  --rh-shadow: 0 2px 12px rgba(30, 86, 245, 0.06);
  --rh-shadow-hover: 0 8px 24px rgba(30, 86, 245, 0.12);
  --rh-radius: 14px;
  --rh-radius-sm: 10px;
  --rh-transition: 0.22s ease;
}

/* —— Page header —— */
.referral_recent_s .rh-page-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem 1.5rem;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--rh-border);
}

.referral_recent_s .rh-page-header__title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.15rem;
  color: #1e56f5;
}

body:not(.light_theme) .refrefer_earn_outer .rh-page-header__title {
  color: #fff;
}

.referral_recent_s .rh-page-header__subtitle {
  max-width: 32rem;
  line-height: 1.45;
}

.referral_recent_s .rh-page-header__controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
}

.referral_recent_s .rh-level-filter {
  min-width: 8.5rem;
  max-width: 12rem;
  border-radius: 50px;
  border: 1px solid var(--rh-border-strong);
  background: var(--rh-surface);
  color: var(--rh-text);
  font-size: 0.8rem;
  padding-top: 0.35rem;
  padding-bottom: 0.35rem;
  padding-left: 0.85rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.referral_recent_s .rh-level-filter:focus {
  border-color: var(--rh-brand);
  box-shadow: 0 0 0 0.2rem var(--rh-brand-soft);
  outline: none;
}

/* —— Summary cards —— */
.referral_recent_s .rh-summary-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.75rem 1rem;
  margin-bottom: 1.35rem;
}

@media (max-width: 1200px) {
  .referral_recent_s .rh-summary-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .referral_recent_s .rh-summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 400px) {
  .referral_recent_s .rh-summary-grid {
    grid-template-columns: 1fr;
  }
}

.referral_recent_s .rh-stat-card {
  background: var(--rh-surface);
  border: 1px solid var(--rh-border);
  border-radius: var(--rh-radius);
  padding: 1rem 1.1rem;
  box-shadow: var(--rh-shadow);
  transition: transform var(--rh-transition), box-shadow var(--rh-transition), border-color var(--rh-transition);
  min-width: 0;
  position: relative;
  overflow: hidden;
}

.referral_recent_s .rh-stat-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--rh-brand) 0%, var(--rh-brand-mid) 100%);
  opacity: 0;
  transition: opacity var(--rh-transition);
}

.referral_recent_s .rh-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--rh-shadow-hover);
  border-color: var(--rh-brand-border);
}

.referral_recent_s .rh-stat-card:hover::after {
  opacity: 1;
}

.referral_recent_s .rh-stat-card--earn::after,
.referral_recent_s .rh-stat-card--pending::after,
.referral_recent_s .rh-stat-card--signup::after {
  opacity: 0.35;
}

.referral_recent_s .rh-stat-card--earn::after {
  background: linear-gradient(90deg, var(--rh-success) 0%, #4a9e6f 100%);
}

.referral_recent_s .rh-stat-card--pending::after {
  background: linear-gradient(90deg, #e8a23c 0%, var(--rh-warn) 100%);
}

.referral_recent_s .rh-stat-card--signup::after {
  background: linear-gradient(90deg, var(--rh-brand) 0%, #6b5ce7 100%);
}

.referral_recent_s .rh-stat-card--signup .rh-stat-card__value {
  color: var(--rh-brand);
}

.referral_recent_s .rh-stat-card__label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--rh-muted);
  font-weight: 600;
  margin-bottom: 0.4rem;
}

.referral_recent_s .rh-stat-card__value {
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--rh-text-heading);
  word-break: break-word;
}

.referral_recent_s .rh-stat-card--earn .rh-stat-card__value {
  color: var(--rh-success);
}

.referral_recent_s .rh-stat-card--pending .rh-stat-card__value {
  color: var(--rh-warn);
}

.referral_recent_s .rh-stat-card__hint {
  font-size: 0.7rem;
  color: #8b939e;
  margin-top: 0.3rem;
}

/* —— List shell —— */
/* Global .table-responsive caps height at 460px and clips this tree — reset on refer page */
.referral_recent_s .dashboard_recent_s .table-responsive {
  max-height: none;
  min-height: 0;
  overflow: visible;
}

.referral_recent_s .rh-list-shell {
  background: var(--rh-surface-muted);
  border-radius: var(--rh-radius);
  padding: 0.6rem;
  border: 1px solid var(--rh-border);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
  min-width: 0;
  overflow: visible;
}

/* Scrollable list body — long networks stay inside the dashboard */
.referral_recent_s .rh-list-scroll {
  max-height: min(72vh, 720px);
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding-right: 0.2rem;
  padding-bottom: 1.25rem;
  margin-right: -0.1rem;
  box-sizing: border-box;
}

.referral_recent_s .rh-list-scroll::-webkit-scrollbar {
  width: 8px;
}

.referral_recent_s .rh-list-scroll::-webkit-scrollbar-track {
  background: var(--rh-surface-muted);
  border-radius: 4px;
}

.referral_recent_s .rh-list-scroll::-webkit-scrollbar-thumb {
  background: var(--rh-border-strong);
  border-radius: 4px;
}

.referral_recent_s .rh-list-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--rh-muted);
}

.referral_recent_s .rh-m-list-scroll {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: min(72vh, 720px);
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  min-width: 0;
  padding-right: 0.2rem;
  padding-bottom: 1.25rem;
  margin-right: -0.1rem;
  box-sizing: border-box;
}

.referral_recent_s .order_history_mobile_view {
  overflow: visible;
}

.referral_recent_s .rh-m-list-scroll::-webkit-scrollbar {
  width: 6px;
}

.referral_recent_s .rh-m-list-scroll::-webkit-scrollbar-track {
  background: var(--rh-surface-muted);
  border-radius: 3px;
}

.referral_recent_s .rh-m-list-scroll::-webkit-scrollbar-thumb {
  background: var(--rh-border-strong);
  border-radius: 3px;
}

.referral_recent_s .rh-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.referral_recent_s .rh-empty-filter {
  background: var(--rh-surface);
  border-radius: var(--rh-radius-sm);
  border: 1px dashed var(--rh-border-strong);
}

/* —— Tree row (desktop) —— */
.referral_recent_s .rh-row {
  --guide: rgba(30, 86, 245, 0.28);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.65rem 0.75rem;
  min-height: 4.5rem;
  background: var(--rh-surface);
  border: 1px solid var(--rh-border);
  border-radius: var(--rh-radius-sm);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  padding: 0.65rem 0.75rem 0.65rem 0.4rem;
  position: relative;
  transition: transform var(--rh-transition), box-shadow var(--rh-transition), border-color var(--rh-transition), background var(--rh-transition);
  animation: rh-fade-in 0.4s ease backwards;
}

.referral_recent_s .rh-row__sno {
  flex: 0 0 auto;
  min-width: 1.75rem;
  max-width: 2.75rem;
  text-align: center;
  font-size: 0.72rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--rh-muted);
  line-height: 1.2;
  -webkit-user-select: none;
          user-select: none;
  padding: 0 0.1rem;
}

.referral_recent_s .rh-row__sno--empty {
  min-width: 1.75rem;
  max-width: 2.75rem;
  padding: 0 0.1rem;
  visibility: hidden;
  pointer-events: none;
}

.referral_recent_s .rh-row[data-depth="0"] {
  border-left: 3px solid var(--rh-brand);
}

.referral_recent_s .rh-row[data-depth]:not([data-depth="0"]) {
  border-left: 2px solid var(--rh-guide, var(--guide));
  margin-left: 0.15rem;
}

@keyframes rh-fade-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.referral_recent_s .rh-row:hover {
  border-color: var(--rh-brand-border);
  box-shadow: var(--rh-shadow);
  background: #fbfcff;
  transform: translateY(-1px);
}

.referral_recent_s .rh-row__gutter {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
}

.referral_recent_s .rh-row__guides {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-height: 2rem;
}

.referral_recent_s .rh-tree-vline {
  width: 10px;
  min-height: 2rem;
  border-left: 2px solid var(--guide);
  margin-right: 1px;
  border-radius: 0;
  box-sizing: content-box;
  position: relative;
}

.referral_recent_s .rh-tree-vline::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 7px;
  height: 1px;
  background: var(--guide);
  transform: translateY(2px);
}

/* Expand (Remix, matches site icons) */
.referral_recent_s .rh-expand,
.referral_recent_s .rh-expand--spacer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 8px;
  border: 1px solid var(--rh-brand-border);
  background: var(--rh-brand-soft);
  color: var(--rh-brand);
  flex-shrink: 0;
  transition: background var(--rh-transition), transform var(--rh-transition);
}

.referral_recent_s .rh-expand--spacer {
  border: 1px dashed var(--rh-border-strong);
  background: var(--rh-surface-muted);
  color: var(--rh-muted);
  opacity: 0.5;
  pointer-events: none;
}

.referral_recent_s button.rh-expand {
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.referral_recent_s button.rh-expand:hover:not(:disabled) {
  background: rgba(30, 86, 245, 0.18);
  color: var(--rh-brand-mid);
}

.referral_recent_s button.rh-expand:disabled {
  cursor: wait;
  opacity: 0.7;
}

.referral_recent_s .rh-expand i,
.referral_recent_s .rh-expand--open {
  font-size: 1rem;
  transition: transform 0.3s ease;
  display: inline-block;
}

.referral_recent_s .rh-expand--open,
.referral_recent_s i.rh-expand--open {
  transform: rotate(90deg);
}

/* Avatar — brand gradient */
.referral_recent_s .rh-avatar {
  width: 2.5rem;
  height: 2.5rem;
  min-width: 2.5rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.8rem;
  color: #fff;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(30, 86, 245, 0.25);
  transition: transform var(--rh-transition);
}

.referral_recent_s .rh-avatar--brand {
  background: linear-gradient(140deg, var(--rh-brand) 0%, #1746c7 100%);
}

.referral_recent_s .rh-avatar--sm {
  width: 2.45rem;
  height: 2.45rem;
  min-width: 2.45rem;
  font-size: 0.75rem;
}

.referral_recent_s .rh-row:hover .rh-avatar {
  transform: scale(1.03);
}

/* Main text block */
.referral_recent_s .rh-row__main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.2rem;
}

.referral_recent_s .rh-name {
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--rh-text-heading);
  line-height: 1.3;
  word-break: break-word;
}

.referral_recent_s .rh-meta {
  font-size: 0.78rem;
  color: var(--rh-muted);
  line-height: 1.4;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
}

.referral_recent_s .rh-meta__dot {
  opacity: 0.6;
}

/* Badges (KYC = site success) */
.referral_recent_s .rh-row__badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem;
  flex-shrink: 0;
  max-width: 12rem;
}

.referral_recent_s .rh-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 0.64rem;
  font-weight: 600;
  padding: 0.22rem 0.5rem;
  border-radius: 6px;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
  border: 1px solid transparent;
}

.referral_recent_s .rh-badge--kyc {
  background: var(--rh-success-soft);
  color: #2a8f5c;
  border-color: rgba(94, 186, 137, 0.35);
}

.referral_recent_s .rh-badge--kyc-p {
  background: var(--rh-warn-soft);
  color: var(--rh-warn);
  border-color: rgba(180, 92, 6, 0.25);
}

.referral_recent_s .rh-badge--lvl {
  background: var(--rh-brand-soft);
  color: var(--rh-brand);
  border-color: var(--rh-brand-border);
}

/* Earnings */
.referral_recent_s .rh-row__earn {
  flex-shrink: 0;
  min-width: 5.5rem;
  text-align: right;
}

.referral_recent_s .rh-earn {
  font-size: 0.85rem;
  font-weight: 600;
  display: inline-block;
}

.referral_recent_s .rh-earn--yes {
  color: var(--rh-success);
}

.referral_recent_s .rh-earn--no {
  color: #adb5bd;
  font-weight: 500;
}

.referral_recent_s .rh-row__chev {
  color: #adb5bd;
  font-size: 1.1rem;
  flex-shrink: 0;
  opacity: 0.6;
  transition: transform var(--rh-transition), opacity var(--rh-transition);
}

.referral_recent_s .rh-row:hover .rh-row__chev {
  color: var(--rh-brand);
  opacity: 1;
  transform: translateX(2px);
}

/* Mobile cards */
.referral_recent_s .rh-m-sno {
  flex: 0 0 auto;
  min-width: 1.5rem;
  text-align: center;
  font-size: 0.7rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
  -webkit-user-select: none;
          user-select: none;
  padding-top: 0.45rem;
}

.referral_recent_s .rh-m-sno--empty {
  min-width: 1.5rem;
  padding-top: 0.45rem;
  visibility: hidden;
  pointer-events: none;
}

.referral_recent_s .rh-m-card {
  background: var(--rh-surface);
  border-radius: var(--rh-radius);
  border: 1px solid var(--rh-border);
  box-shadow: var(--rh-shadow);
  padding: 0.9rem 1rem;
  transition: box-shadow var(--rh-transition);
  animation: rh-fade-in 0.4s ease backwards;
  flex-shrink: 0;
}

.referral_recent_s .rh-m-card:hover {
  box-shadow: var(--rh-shadow-hover);
  border-color: var(--rh-brand-border);
}

.referral_recent_s .rh-m-title {
  color: var(--rh-text-heading);
  font-size: 0.95rem;
}

.referral_recent_s .rh-m-grid {
  display: grid;
  grid-template-columns: minmax(4rem, auto) 1fr;
  gap: 0.3rem 0.5rem;
  font-size: 0.75rem;
  color: var(--rh-muted);
}

.referral_recent_s .rh-m-grid span:nth-child(odd) {
  color: #8b939e;
}

/* How it works */
.referral_recent_s .rh-how-it-works {
  margin-top: 2rem;
  padding: 1.25rem 1.35rem;
  background: var(--rh-surface-muted);
  border: 1px solid var(--rh-border);
  border-radius: var(--rh-radius);
  border-left: 4px solid var(--rh-brand);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.referral_recent_s .rh-how-it-works__title {
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #1e56f5;
}

.referral_recent_s .rh-how-it-works__list {
  margin: 0;
  padding-left: 1.1rem;
  color: var(--rh-text);
  font-size: 0.86rem;
  line-height: 1.7;
}

.referral_recent_s .rh-how-it-works__list li {
  margin-bottom: 0.25rem;
}

/* Dark / non–light: soften without breaking brand */
body:not(.light_theme) .refrefer_earn_outer .rh-referral-premium,
body.dark_theme .rh-referral-premium {
  --rh-surface: #1a1d24;
  --rh-surface-muted: #12151a;
  --rh-border: rgba(255, 255, 255, 0.08);
  --rh-border-strong: rgba(255, 255, 255, 0.1);
  --rh-text: rgba(255, 255, 255, 0.8);
  --rh-text-heading: #fff;
  --rh-muted: #9aa3ad;
  --rh-guide: rgba(120, 160, 255, 0.35);
  --rh-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
  --rh-shadow-hover: 0 8px 24px rgba(0, 0, 0, 0.35);
}

body:not(.light_theme) .refrefer_earn_outer .rh-row:hover,
body.dark_theme .rh-row:hover {
  background: #1e232d;
}

body:not(.light_theme) .refrefer_earn_outer .rh-stat-card,
body.dark_theme .rh-stat-card {
  background: #1a1d24;
}

body:not(.light_theme) .refrefer_earn_outer .rh-how-it-works,
body.dark_theme .rh-how-it-works {
  background: #12151a;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ReferalPage/referralHistoryV2.css"],"names":[],"mappings":"AAAA,8FAA8F;AAC9F;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,0CAA0C;EAC1C,qBAAqB;EACrB,2CAA2C;EAC3C,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,+CAA+C;EAC/C,qDAAqD;EACrD,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,oBAAoB;EACpB,4BAA4B;EAC5B,8GAA8G;EAC9G,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gFAAgF;EAChF,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB,4FAA4F;AAC5F;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,kDAAkD;EAClD,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;EAC5B,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,yCAAyC;EACzC,uCAAuC;EACvC,kBAAkB;EAClB,+IAA+I;EAC/I,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oDAAoD;EACpD,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;EACd,2EAA2E;AAC7E;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,0CAA0C;EAC1C,cAAc;EACd,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA,aAAa;AACb;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,wEAAwE;AAC1E;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;EAC5B,oBAAoB;EACpB,2CAA2C;EAC3C,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;;EAEE,qBAAqB;EACrB,2BAA2B;EAC3B,sCAAsC;EACtC,4CAA4C;EAC5C,mCAAmC;EACnC,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB","sourcesContent":["/* Referral History — premium layout, matches site theme (Zillion: #1E56F5, success #5EBA89) */\n.referral_recent_s.rh-referral-premium {\n  /* Align with light_theme + global dashboard */\n  --rh-brand: #1e56f5;\n  --rh-brand-mid: #2156f5;\n  --rh-brand-soft: rgba(30, 86, 245, 0.1);\n  --rh-brand-border: rgba(30, 86, 245, 0.22);\n  --rh-success: #5eba89;\n  --rh-success-soft: rgba(94, 186, 137, 0.16);\n  --rh-surface: #ffffff;\n  --rh-surface-muted: #f8f9fa;\n  --rh-surface-elev: #f0f0f0;\n  --rh-border: #f0f0f0;\n  --rh-border-strong: #e2e4e8;\n  --rh-text: rgba(0, 0, 0, 0.72);\n  --rh-text-heading: #000000b8;\n  --rh-muted: #6c757d;\n  --rh-warn: #b45c06;\n  --rh-warn-soft: rgba(180, 92, 6, 0.12);\n  --rh-shadow: 0 2px 12px rgba(30, 86, 245, 0.06);\n  --rh-shadow-hover: 0 8px 24px rgba(30, 86, 245, 0.12);\n  --rh-radius: 14px;\n  --rh-radius-sm: 10px;\n  --rh-transition: 0.22s ease;\n}\n\n/* —— Page header —— */\n.referral_recent_s .rh-page-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 1rem 1.5rem;\n  margin-bottom: 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--rh-border);\n}\n\n.referral_recent_s .rh-page-header__title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 0.15rem;\n  color: #1e56f5;\n}\n\nbody:not(.light_theme) .refrefer_earn_outer .rh-page-header__title {\n  color: #fff;\n}\n\n.referral_recent_s .rh-page-header__subtitle {\n  max-width: 32rem;\n  line-height: 1.45;\n}\n\n.referral_recent_s .rh-page-header__controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 0.75rem;\n}\n\n.referral_recent_s .rh-level-filter {\n  min-width: 8.5rem;\n  max-width: 12rem;\n  border-radius: 50px;\n  border: 1px solid var(--rh-border-strong);\n  background: var(--rh-surface);\n  color: var(--rh-text);\n  font-size: 0.8rem;\n  padding-top: 0.35rem;\n  padding-bottom: 0.35rem;\n  padding-left: 0.85rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.referral_recent_s .rh-level-filter:focus {\n  border-color: var(--rh-brand);\n  box-shadow: 0 0 0 0.2rem var(--rh-brand-soft);\n  outline: none;\n}\n\n/* —— Summary cards —— */\n.referral_recent_s .rh-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 0.75rem 1rem;\n  margin-bottom: 1.35rem;\n}\n\n@media (max-width: 1200px) {\n  .referral_recent_s .rh-summary-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 992px) {\n  .referral_recent_s .rh-summary-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 400px) {\n  .referral_recent_s .rh-summary-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.referral_recent_s .rh-stat-card {\n  background: var(--rh-surface);\n  border: 1px solid var(--rh-border);\n  border-radius: var(--rh-radius);\n  padding: 1rem 1.1rem;\n  box-shadow: var(--rh-shadow);\n  transition: transform var(--rh-transition), box-shadow var(--rh-transition), border-color var(--rh-transition);\n  min-width: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.referral_recent_s .rh-stat-card::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--rh-brand) 0%, var(--rh-brand-mid) 100%);\n  opacity: 0;\n  transition: opacity var(--rh-transition);\n}\n\n.referral_recent_s .rh-stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--rh-shadow-hover);\n  border-color: var(--rh-brand-border);\n}\n\n.referral_recent_s .rh-stat-card:hover::after {\n  opacity: 1;\n}\n\n.referral_recent_s .rh-stat-card--earn::after,\n.referral_recent_s .rh-stat-card--pending::after,\n.referral_recent_s .rh-stat-card--signup::after {\n  opacity: 0.35;\n}\n\n.referral_recent_s .rh-stat-card--earn::after {\n  background: linear-gradient(90deg, var(--rh-success) 0%, #4a9e6f 100%);\n}\n\n.referral_recent_s .rh-stat-card--pending::after {\n  background: linear-gradient(90deg, #e8a23c 0%, var(--rh-warn) 100%);\n}\n\n.referral_recent_s .rh-stat-card--signup::after {\n  background: linear-gradient(90deg, var(--rh-brand) 0%, #6b5ce7 100%);\n}\n\n.referral_recent_s .rh-stat-card--signup .rh-stat-card__value {\n  color: var(--rh-brand);\n}\n\n.referral_recent_s .rh-stat-card__label {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--rh-muted);\n  font-weight: 600;\n  margin-bottom: 0.4rem;\n}\n\n.referral_recent_s .rh-stat-card__value {\n  font-size: 1.35rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--rh-text-heading);\n  word-break: break-word;\n}\n\n.referral_recent_s .rh-stat-card--earn .rh-stat-card__value {\n  color: var(--rh-success);\n}\n\n.referral_recent_s .rh-stat-card--pending .rh-stat-card__value {\n  color: var(--rh-warn);\n}\n\n.referral_recent_s .rh-stat-card__hint {\n  font-size: 0.7rem;\n  color: #8b939e;\n  margin-top: 0.3rem;\n}\n\n/* —— List shell —— */\n/* Global .table-responsive caps height at 460px and clips this tree — reset on refer page */\n.referral_recent_s .dashboard_recent_s .table-responsive {\n  max-height: none;\n  min-height: 0;\n  overflow: visible;\n}\n\n.referral_recent_s .rh-list-shell {\n  background: var(--rh-surface-muted);\n  border-radius: var(--rh-radius);\n  padding: 0.6rem;\n  border: 1px solid var(--rh-border);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);\n  min-width: 0;\n  overflow: visible;\n}\n\n/* Scrollable list body — long networks stay inside the dashboard */\n.referral_recent_s .rh-list-scroll {\n  max-height: min(72vh, 720px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  padding-right: 0.2rem;\n  padding-bottom: 1.25rem;\n  margin-right: -0.1rem;\n  box-sizing: border-box;\n}\n\n.referral_recent_s .rh-list-scroll::-webkit-scrollbar {\n  width: 8px;\n}\n\n.referral_recent_s .rh-list-scroll::-webkit-scrollbar-track {\n  background: var(--rh-surface-muted);\n  border-radius: 4px;\n}\n\n.referral_recent_s .rh-list-scroll::-webkit-scrollbar-thumb {\n  background: var(--rh-border-strong);\n  border-radius: 4px;\n}\n\n.referral_recent_s .rh-list-scroll::-webkit-scrollbar-thumb:hover {\n  background: var(--rh-muted);\n}\n\n.referral_recent_s .rh-m-list-scroll {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-height: min(72vh, 720px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  min-width: 0;\n  padding-right: 0.2rem;\n  padding-bottom: 1.25rem;\n  margin-right: -0.1rem;\n  box-sizing: border-box;\n}\n\n.referral_recent_s .order_history_mobile_view {\n  overflow: visible;\n}\n\n.referral_recent_s .rh-m-list-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.referral_recent_s .rh-m-list-scroll::-webkit-scrollbar-track {\n  background: var(--rh-surface-muted);\n  border-radius: 3px;\n}\n\n.referral_recent_s .rh-m-list-scroll::-webkit-scrollbar-thumb {\n  background: var(--rh-border-strong);\n  border-radius: 3px;\n}\n\n.referral_recent_s .rh-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.referral_recent_s .rh-empty-filter {\n  background: var(--rh-surface);\n  border-radius: var(--rh-radius-sm);\n  border: 1px dashed var(--rh-border-strong);\n}\n\n/* —— Tree row (desktop) —— */\n.referral_recent_s .rh-row {\n  --guide: rgba(30, 86, 245, 0.28);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.65rem 0.75rem;\n  min-height: 4.5rem;\n  background: var(--rh-surface);\n  border: 1px solid var(--rh-border);\n  border-radius: var(--rh-radius-sm);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  padding: 0.65rem 0.75rem 0.65rem 0.4rem;\n  position: relative;\n  transition: transform var(--rh-transition), box-shadow var(--rh-transition), border-color var(--rh-transition), background var(--rh-transition);\n  animation: rh-fade-in 0.4s ease backwards;\n}\n\n.referral_recent_s .rh-row__sno {\n  flex: 0 0 auto;\n  min-width: 1.75rem;\n  max-width: 2.75rem;\n  text-align: center;\n  font-size: 0.72rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: var(--rh-muted);\n  line-height: 1.2;\n  user-select: none;\n  padding: 0 0.1rem;\n}\n\n.referral_recent_s .rh-row__sno--empty {\n  min-width: 1.75rem;\n  max-width: 2.75rem;\n  padding: 0 0.1rem;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.referral_recent_s .rh-row[data-depth=\"0\"] {\n  border-left: 3px solid var(--rh-brand);\n}\n\n.referral_recent_s .rh-row[data-depth]:not([data-depth=\"0\"]) {\n  border-left: 2px solid var(--rh-guide, var(--guide));\n  margin-left: 0.15rem;\n}\n\n@keyframes rh-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.referral_recent_s .rh-row:hover {\n  border-color: var(--rh-brand-border);\n  box-shadow: var(--rh-shadow);\n  background: #fbfcff;\n  transform: translateY(-1px);\n}\n\n.referral_recent_s .rh-row__gutter {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.referral_recent_s .rh-row__guides {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  min-height: 2rem;\n}\n\n.referral_recent_s .rh-tree-vline {\n  width: 10px;\n  min-height: 2rem;\n  border-left: 2px solid var(--guide);\n  margin-right: 1px;\n  border-radius: 0;\n  box-sizing: content-box;\n  position: relative;\n}\n\n.referral_recent_s .rh-tree-vline::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 7px;\n  height: 1px;\n  background: var(--guide);\n  transform: translateY(2px);\n}\n\n/* Expand (Remix, matches site icons) */\n.referral_recent_s .rh-expand,\n.referral_recent_s .rh-expand--spacer {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.9rem;\n  height: 1.9rem;\n  border-radius: 8px;\n  border: 1px solid var(--rh-brand-border);\n  background: var(--rh-brand-soft);\n  color: var(--rh-brand);\n  flex-shrink: 0;\n  transition: background var(--rh-transition), transform var(--rh-transition);\n}\n\n.referral_recent_s .rh-expand--spacer {\n  border: 1px dashed var(--rh-border-strong);\n  background: var(--rh-surface-muted);\n  color: var(--rh-muted);\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.referral_recent_s button.rh-expand {\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.referral_recent_s button.rh-expand:hover:not(:disabled) {\n  background: rgba(30, 86, 245, 0.18);\n  color: var(--rh-brand-mid);\n}\n\n.referral_recent_s button.rh-expand:disabled {\n  cursor: wait;\n  opacity: 0.7;\n}\n\n.referral_recent_s .rh-expand i,\n.referral_recent_s .rh-expand--open {\n  font-size: 1rem;\n  transition: transform 0.3s ease;\n  display: inline-block;\n}\n\n.referral_recent_s .rh-expand--open,\n.referral_recent_s i.rh-expand--open {\n  transform: rotate(90deg);\n}\n\n/* Avatar — brand gradient */\n.referral_recent_s .rh-avatar {\n  width: 2.5rem;\n  height: 2.5rem;\n  min-width: 2.5rem;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 0.8rem;\n  color: #fff;\n  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.12);\n  flex-shrink: 0;\n  box-shadow: 0 1px 4px rgba(30, 86, 245, 0.25);\n  transition: transform var(--rh-transition);\n}\n\n.referral_recent_s .rh-avatar--brand {\n  background: linear-gradient(140deg, var(--rh-brand) 0%, #1746c7 100%);\n}\n\n.referral_recent_s .rh-avatar--sm {\n  width: 2.45rem;\n  height: 2.45rem;\n  min-width: 2.45rem;\n  font-size: 0.75rem;\n}\n\n.referral_recent_s .rh-row:hover .rh-avatar {\n  transform: scale(1.03);\n}\n\n/* Main text block */\n.referral_recent_s .rh-row__main {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.2rem;\n}\n\n.referral_recent_s .rh-name {\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: var(--rh-text-heading);\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.referral_recent_s .rh-meta {\n  font-size: 0.78rem;\n  color: var(--rh-muted);\n  line-height: 1.4;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.referral_recent_s .rh-meta__dot {\n  opacity: 0.6;\n}\n\n/* Badges (KYC = site success) */\n.referral_recent_s .rh-row__badges {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.4rem;\n  flex-shrink: 0;\n  max-width: 12rem;\n}\n\n.referral_recent_s .rh-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  font-size: 0.64rem;\n  font-weight: 600;\n  padding: 0.22rem 0.5rem;\n  border-radius: 6px;\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  white-space: nowrap;\n  border: 1px solid transparent;\n}\n\n.referral_recent_s .rh-badge--kyc {\n  background: var(--rh-success-soft);\n  color: #2a8f5c;\n  border-color: rgba(94, 186, 137, 0.35);\n}\n\n.referral_recent_s .rh-badge--kyc-p {\n  background: var(--rh-warn-soft);\n  color: var(--rh-warn);\n  border-color: rgba(180, 92, 6, 0.25);\n}\n\n.referral_recent_s .rh-badge--lvl {\n  background: var(--rh-brand-soft);\n  color: var(--rh-brand);\n  border-color: var(--rh-brand-border);\n}\n\n/* Earnings */\n.referral_recent_s .rh-row__earn {\n  flex-shrink: 0;\n  min-width: 5.5rem;\n  text-align: right;\n}\n\n.referral_recent_s .rh-earn {\n  font-size: 0.85rem;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.referral_recent_s .rh-earn--yes {\n  color: var(--rh-success);\n}\n\n.referral_recent_s .rh-earn--no {\n  color: #adb5bd;\n  font-weight: 500;\n}\n\n.referral_recent_s .rh-row__chev {\n  color: #adb5bd;\n  font-size: 1.1rem;\n  flex-shrink: 0;\n  opacity: 0.6;\n  transition: transform var(--rh-transition), opacity var(--rh-transition);\n}\n\n.referral_recent_s .rh-row:hover .rh-row__chev {\n  color: var(--rh-brand);\n  opacity: 1;\n  transform: translateX(2px);\n}\n\n/* Mobile cards */\n.referral_recent_s .rh-m-sno {\n  flex: 0 0 auto;\n  min-width: 1.5rem;\n  text-align: center;\n  font-size: 0.7rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.2;\n  user-select: none;\n  padding-top: 0.45rem;\n}\n\n.referral_recent_s .rh-m-sno--empty {\n  min-width: 1.5rem;\n  padding-top: 0.45rem;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.referral_recent_s .rh-m-card {\n  background: var(--rh-surface);\n  border-radius: var(--rh-radius);\n  border: 1px solid var(--rh-border);\n  box-shadow: var(--rh-shadow);\n  padding: 0.9rem 1rem;\n  transition: box-shadow var(--rh-transition);\n  animation: rh-fade-in 0.4s ease backwards;\n  flex-shrink: 0;\n}\n\n.referral_recent_s .rh-m-card:hover {\n  box-shadow: var(--rh-shadow-hover);\n  border-color: var(--rh-brand-border);\n}\n\n.referral_recent_s .rh-m-title {\n  color: var(--rh-text-heading);\n  font-size: 0.95rem;\n}\n\n.referral_recent_s .rh-m-grid {\n  display: grid;\n  grid-template-columns: minmax(4rem, auto) 1fr;\n  gap: 0.3rem 0.5rem;\n  font-size: 0.75rem;\n  color: var(--rh-muted);\n}\n\n.referral_recent_s .rh-m-grid span:nth-child(odd) {\n  color: #8b939e;\n}\n\n/* How it works */\n.referral_recent_s .rh-how-it-works {\n  margin-top: 2rem;\n  padding: 1.25rem 1.35rem;\n  background: var(--rh-surface-muted);\n  border: 1px solid var(--rh-border);\n  border-radius: var(--rh-radius);\n  border-left: 4px solid var(--rh-brand);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.referral_recent_s .rh-how-it-works__title {\n  font-size: 0.95rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  color: #1e56f5;\n}\n\n.referral_recent_s .rh-how-it-works__list {\n  margin: 0;\n  padding-left: 1.1rem;\n  color: var(--rh-text);\n  font-size: 0.86rem;\n  line-height: 1.7;\n}\n\n.referral_recent_s .rh-how-it-works__list li {\n  margin-bottom: 0.25rem;\n}\n\n/* Dark / non–light: soften without breaking brand */\nbody:not(.light_theme) .refrefer_earn_outer .rh-referral-premium,\nbody.dark_theme .rh-referral-premium {\n  --rh-surface: #1a1d24;\n  --rh-surface-muted: #12151a;\n  --rh-border: rgba(255, 255, 255, 0.08);\n  --rh-border-strong: rgba(255, 255, 255, 0.1);\n  --rh-text: rgba(255, 255, 255, 0.8);\n  --rh-text-heading: #fff;\n  --rh-muted: #9aa3ad;\n  --rh-guide: rgba(120, 160, 255, 0.35);\n  --rh-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);\n  --rh-shadow-hover: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n\nbody:not(.light_theme) .refrefer_earn_outer .rh-row:hover,\nbody.dark_theme .rh-row:hover {\n  background: #1e232d;\n}\n\nbody:not(.light_theme) .refrefer_earn_outer .rh-stat-card,\nbody.dark_theme .rh-stat-card {\n  background: #1a1d24;\n}\n\nbody:not(.light_theme) .refrefer_earn_outer .rh-how-it-works,\nbody.dark_theme .rh-how-it-works {\n  background: #12151a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
